import {
  CmsApiBlock,
  CmsApiBlockType,
} from 'modules/cms/api/types/CmsApiBlock';
import { CmsMappedBlock } from 'modules/cms/mappers/CmsMappedBlock';

const blocksWithoutDividers: CmsApiBlockType[] = [
  'GRAD_CTA_HERO',
  'CTA_HERO',
  'STICKY_HEADER_LINKS',
  'STICKY_HEADER_LINKS_GRAD',
  'EMAIL_CAMPAIGN_SIGNUP_SINGLE',
  'EMAIL_CAMPAIGN_SIGNUP_DOUBLE',
  'FORM_BUILDER',
  'FLASH_CARD_QUIZ',
  'SIGN_UP',
  'SCROLL_TRACKING',
  'RECOMMENDED_JOBS',
];

export function mustNotHaveDivider<TBlock extends CmsApiBlock>(
  block: CmsMappedBlock<TBlock>,
) {
  return blocksWithoutDividers.includes(block.type) || block.mustNotHaveDivider;
}
